import { findLocationAnomalies } from "@nova/calculate-geospatial"
import { UploadFlowWarnings, ID, UploadFlowWarningColors } from "@nova/constants"
import { set } from "nodash"
import {
    getNoLocationIds,
    getNoThermalDataIds,
    getObliqueIds,
    getZoomedIds,
} from "panels/content/side-panel/upload-flow/GenericWarningProcessors"
import { InfraredImageState } from "./InfraredImageSlice"

export const InfraredUploadFlowWarnings: Record<
    ID,
    Record<UploadFlowWarnings, { ids: ID[]; color: string }>
> = {}

const addWarning = (
    flightId: string,
    imageColors: Record<ID, string>,
    warning: UploadFlowWarnings,
    ids: ID[]
) => {
    set(InfraredUploadFlowWarnings, flightId + "." + warning, {
        ids,
        color: UploadFlowWarningColors[warning],
    })

    return {
        ...imageColors,
        ...Object.fromEntries(ids.map((id) => [id, UploadFlowWarningColors[warning]])),
    }
}

export const infraredWarningProcessor = (flightId: string, uploads: InfraredImageState[]) => {
    let imageColors: Record<ID, string> = {}

    //Attention
    const zoomedIds = getZoomedIds(uploads)
    imageColors = addWarning(flightId, imageColors, UploadFlowWarnings.Zoom, zoomedIds)

    //Warnings
    const obliqueIds = getObliqueIds(uploads)
    imageColors = addWarning(flightId, imageColors, UploadFlowWarnings.Obliques, obliqueIds)

    //Errors
    const noLocationIds = getNoLocationIds(uploads)
    imageColors = addWarning(flightId, imageColors, UploadFlowWarnings.NoLocation, noLocationIds)

    const thermalDataIds = getNoThermalDataIds(uploads)
    imageColors = addWarning(
        flightId,
        imageColors,
        UploadFlowWarnings.NoThermalData,
        thermalDataIds
    )

    const locationAnomalies = findLocationAnomalies(uploads)
    imageColors = addWarning(flightId, imageColors, UploadFlowWarnings.Location, locationAnomalies)

    return imageColors
}
